/**
*
* Spinner
*
*/

import React from 'react';
import PropTypes from 'prop-types';
import styled, { css, keyframes } from 'styled-components';

export const SpinnerWrap = styled('div')`
  margin-top: 100px;
  text-align: center;
`;

const delay = (turn = 0.0) => ` -${turn * 0.16}s`;

const bounce = keyframes`
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
`;

export const Bounce = styled.div`
  width: 18px;
  height: 18px;
  background-color: ${({ bgColor, theme: { brand } }) => (bgColor || brand)};
  ${({ inverse }) => inverse && css`
      background-color: #fff;
    `};
  @media mobile and (max-width: 1024px) {
    ${({ ringo }) => ringo && css`
      background-color: ${({ bgColor, theme: { brand } }) => (bgColor || brand)}
    `};
  }
  border-radius: 100%;
  display: inline-block;
  animation: ${bounce} 1.4s infinite ease-in-out both;
  animation-delay: 4;
  animation-delay: ${({ number }) => (number ? delay(number) : 0)};
`;


class Spinner extends React.PureComponent { // eslint-disable-line react/prefer-stateless-function
  render() {
    const {
      number, bgColor, size, ringo, inverse,
    } = this.props;
    const bounces = [...Array(number).keys()].reverse();

    return (
      <SpinnerWrap>
        {bounces.map(
          (n) => <Bounce key={n} number={n} bgColor={bgColor} size={size} ringo={ringo} inverse={inverse} />,
        )}
      </SpinnerWrap>
    );
  }
}

Spinner.propTypes = {
  number: PropTypes.number,
  bgColor: PropTypes.string,
  size: PropTypes.string,
  ringo: PropTypes.bool,
  inverse: PropTypes.bool,
};

Spinner.defaultProps = {
  number: 3,
};

export default Spinner;
